import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface IssuerState {
    connecting: boolean;
}

const initialState: IssuerState = {
    connecting: false,
};

const issuer = createSlice({
    name: "issuer",
    initialState,
    reducers: {
        setConnecting: (state, action: PayloadAction<boolean>) => {
            state.connecting = action.payload;
        },
    },
});

export const { setConnecting } = issuer.actions;
export default issuer.reducer;
